import React from "react"
import "./GameCard.scss"
import RatingOrange from "./../assets/icons/star_org.png"
import RatingGray from "./../assets/icons/star_gray.png"
import RatingYellow from "./../assets/icons/complete.png"
import {Link} from "react-router-dom"
import { logEvent } from "../Analytics/AnalyticsEvent"
import { screen } from '../Analytics/EventName';
import { reactLocalStorage } from "reactjs-localstorage"
import btnLink from "./../assets/icons/playy.png"
import RatingQuatar from "./../assets/icons/quatar.png"
import RatingHalf from "./../assets/icons/half.png"
import RatingThirdFourth from "./../assets/icons/thirdFourth.png"
function GameCard(props) {
    const {data,play_text} = props
    // const rating = Array(5).fill(0).map((item, i) => (
    //     i <= 4 ? <img key={i} src={RatingYellow} alt="stars" className="mr-1" /> : <img key={i} src={RatingGray} alt="stars" className="mr-1" />
    // ))
    // const rating_four= Array(5).fill(0).map((item, i) => (
    //     i <= 3 ? <img key={i} src={RatingYellow} alt="stars" className="mr-1" /> : <img key={i} src={RatingGray} alt="stars" className="mr-1" />
    // ))
//     const rating=Array(5).fill(0).map((item,i)=>(i<Math.round(parseFloat(data.ratings))
//     ? <img key={i} src={RatingYellow} alt="stars" className="mr-1" />
//    : <img key={i} src={RatingGray} alt="stars" className="mr-1" />
//    ))

//   function rating(number){
//     const num=parseFloat(number)
//     if(num==4.0)
//     {
//         return Array(5).fill(0).map((item,i)=>(i<=3
//             ? <img key={i} src={RatingYellow} alt="stars" className="mr-1 rating-icon" />
//           : <img key={i} src={RatingGray} alt="stars" className="mr-1 rating-icon" />
//            ))
//     }
//     else if(num>=4.0 && num<=4.2)
//     {
//         return Array(5).fill(0).map((item,i)=>(i<=3
//              ? <img key={i} src={RatingYellow} alt="stars" className="mr-1 rating-icon" />
//            : <img key={i} src={RatingQuatar} alt="stars" className="mr-1 rating-icon" />
//             ))
//     }
//     else if(num >=4.3 && num <=4.5)
//     {
//         return Array(5).fill(0).map((item,i)=>(i<=3
//             ? <img key={i} src={RatingYellow} alt="stars" className="mr-1 rating-icon" />
//           : <img key={i} src={RatingHalf} alt="stars" className="mr-1 rating-icon" />
//            ))
//     }
//     else if(num >4.5 && num <=4.75)
//     {
//         return Array(5).fill(0).map((item,i)=>(i<=3
//             ? <img key={i} src={RatingYellow} alt="stars" className="mr-1 rating-icon" />
//           : <img key={i} src={RatingThirdFourth} alt="stars" className="mr-1 rating-icon" />
//            ))
//     }
//     else{
//         return Array(5).fill(0).map((item,i)=>(i<=4
//             ? <img key={i} src={RatingYellow} alt="stars" className="mr-1 rating-icon" />
//           : <img key={i} src={RatingThirdFourth} alt="stars" className="mr-1 rating-icon" />
//            ))
//     }
//   }
    
  return (
    <div className="card-bg mb-3" >
         <div className="card-content p-0">
                <div className="media">
                    <div className="media-left">
                        <figure className="image is-120x120">
                            <img src={data.gameImage} alt="Placeholder" className="img-radius" />
                        </figure>
                    </div>
                    {/* <div className="media-content" style={{display:"inline-flex",textAlign:"left"}}>
                        <div className="content p-2" style={{whiteSpace:"break-spaces",marginTop:"-0.5rem"}} >
                        <p className="title is-capitalized is-6 pb-2 text-white">{data.gameName}</p>
                        <p className="subtitle is-7 text-white">{data.gamePlayed}</p>
                        <div className="rating" style={{marginTop:"-0.5rem"}}>
                           
                            <img src={RatingYellow} className="star-icon rating-icon" style={{marginRight:"0.25rem"}}/>
                            <small className="has-text-weight-dark" >{data.ratings}</small>
                           
                        </div>
                        </div>
                        </div>
                        <div className="play-btn-align">
                            <Link to={`/game/${data.category}/${data.id}`}  
                        onClick={() => {
                            console.log("data.gameName", data.gameName + "_cardClick")
                            logEvent(
                                {
                                    screen: screen.homePage,
                                    event : data.gameName + "_cardClick"
                                },
                                {
                                    gameName : data.gameName,
                                    mobile : reactLocalStorage.get('msisdn'),
                                    date: new Date(),
                                });
                        }}>
                           <img src={btnLink} className="play-btn"/>               
                            </Link>
                        </div> */}

                    <div className="p1">
                    <p className="title is-capitalized is-6 text-white text-left" style={{whiteSpace:"break-spaces"}}>{data.gameName}</p>
                    <div className="gamecard-wrapper">
                        <div className="">
                        {/* <p className="title is-capitalized is-6 text-white">{data.gamePlayed}</p> */}
                        <p className="subtitle is-7 text-white">{data.gamePlayed}</p>
                        <div className="text-left mr">
                            <img src={RatingYellow} className="star-icon rating-icon" />
                            <small className="" style={{marginTop:0}}>{data.ratings}</small>
                        </div>
                        </div> 
                        <div style={{position: "absolute",right: "-1rem"}}>
                        <Link to={`/game/${data.category}/${data.id}`}
                        onClick={() => {
                            console.log("data.gameName", data.gameName + "_cardClick")
                            logEvent(
                                {
                                    screen: screen.homePage,
                                    event : data.gameName + "_cardClick"
                                },
                                {
                                    gameName : data.gameName,
                                    mobile : reactLocalStorage.get('msisdn'),
                                    date: new Date(),
                                });
                        }}>
                            <div className="playBtn display">
                            <img src={btnLink} className="play-btn"/>  
                                 </div>
                            </Link>
                        </div>
                    </div>
                    </div>
                </div>
         </div>
    </div>
  )
}

export default GameCard